module.exports = __webpack_public_path__ + "static/media/Steve Jobs_2_t.4b51af92.jpg";